export function getScrollPosition(element) {
  const { top } = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  return top - windowHeight;
}
